import React, { FC } from 'react'
import { ComponentKeyStats } from '../../../models/components/keyStats'
import formatInlineCode from '../../../utils/shortTextFormatting'
import GlobalContainer from '../globalContainer'
import Typography from '../typography'
import { KeyStatsContainer } from './style'
import { FeaturedEventStats, Stats } from './subcomponents'

type Props = {
  data: ComponentKeyStats
  isCustomerStory?: boolean
  isHomePage?: boolean
}

const KeyStats: FC<Props> = ({ data, isCustomerStory, isHomePage = false }) => {
  if (!data) return null
  isCustomerStory = isCustomerStory || data.useCase === 'Small left aligned' || false

  const keyStatsData = {
    theme:
      data.theme && !isCustomerStory ? (data.useCase !== 'Events' ? data.theme : 'Light') : 'Light',
    finePrint: data.keyStatsFinePrint?.finePrint || data.finePrint || '',
    stats: data.stats || [],
    topPadding: data.topPadding || 'None',
    bottomPadding: data.bottomPadding || 'Large',
    eventImage: data.eventImage || '',
  }

  if (keyStatsData.stats.length > 3 && !isCustomerStory) {
    data.useCase === 'Events'
      ? (keyStatsData.stats = data.stats.slice(0, 4))
      : (keyStatsData.stats = data.stats.slice(0, 3))
  }

  return (
    <KeyStatsContainer
      data-cy={`keyStats${isCustomerStory ? '-CustomerStory' : ''}`}
      $background={keyStatsData.theme}
      $topPadding={keyStatsData.topPadding}
      $bottomPadding={keyStatsData.bottomPadding}
      $homePageBg={isHomePage}
      $isCustomerStory={isCustomerStory}
      $useCase={data.useCase}>
      <GlobalContainer
        className={
          data.useCase !== 'Events'
            ? 'KeyStats__Outer-Container'
            : 'KeyStats__Outer-Container-Events'
        }>
        {data.useCase === 'Events' ? (
          <FeaturedEventStats keyStatsData={keyStatsData} isCustomerStory={isCustomerStory} />
        ) : (
          <Stats keyStatsData={keyStatsData} isCustomerStory={isCustomerStory} />
        )}

        {data.useCase !== 'Events' && keyStatsData.finePrint && (
          <Typography type="bodyXS" className="KeyStats__FinePrint">
            {formatInlineCode(keyStatsData.finePrint)}
          </Typography>
        )}
      </GlobalContainer>
    </KeyStatsContainer>
  )
}

export default KeyStats
